import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./globalConfig.js";
import { StyleSheetManager } from "styled-components";
import { ThemeProvider as MuiThemeProvider, } from "@mui/material/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import CssBaseline from "@mui/material/CssBaseline";
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { darkTheme } from "./theme";
import { createMuiThemeFromStyled } from "./buildMuiTheme";
// Lazy-loaded components
const Pricing = () => import(/* webpackChunkName: "Pricing" */ "./Pricing.jsx");
const Teams = () => import(/* webpackChunkName: "Teams" */ "./team/index.js");
const MainForm = () => import(/* webpackChunkName: "MainForm" */ "./agileForm/MainForm.js");
const BillingUpdate = () => import(/* webpackChunkName: "BillingUpdater" */ "./billing/BillingEntry");
const PpcPage = () => import(/* webpackChunkName: "PpcPage" */ "./ppc/index.js");
const PromoLander = () => import(/* webpackChunkName: "Promo Lander" */ "./promoLander/index.js");
// const SocialProof = () => import(/* webpackChunkName: "SocialProof" */ './components/SocialProof');
const styledTheme = darkTheme;
const muiTheme = createMuiThemeFromStyled(styledTheme);
document.addEventListener("DOMContentLoaded", () => {
    const ensureGlobalStylesheet = (href) => {
        if (!document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        }
    };
    const mountInDom = (hostElement, element) => {
        if (!hostElement)
            return;
        ensureGlobalStylesheet("/styles.css");
        const root = createRoot(hostElement);
        root.render(_jsx(MuiThemeProvider, { theme: muiTheme, children: _jsx(StyledThemeProvider, { theme: styledTheme, children: _jsxs(StyleSheetManager, { target: document.head, children: [_jsx(CssBaseline, {}), _jsx(Suspense, { fallback: _jsx("div", { children: "Loading..." }), children: element })] }) }) }));
    };
    const mountInShadow = (hostElement, element) => {
        if (!hostElement)
            return;
        const shadowRoot = hostElement.attachShadow({ mode: "open" });
        // Optional: external CSS
        const style = document.createElement("link");
        style.rel = "stylesheet";
        style.href = "/styles.css";
        shadowRoot.appendChild(style);
        // MUI + Emotion setup
        const emotionCache = createCache({
            key: 'mui-shadow',
            container: shadowRoot,
        });
        const mountPoint = document.createElement("div");
        shadowRoot.appendChild(mountPoint);
        const root = createRoot(mountPoint);
        root.render(_jsx(CacheProvider, { value: emotionCache, children: _jsx(MuiThemeProvider, { theme: muiTheme, children: _jsx(StyledThemeProvider, { theme: styledTheme, children: _jsx(StyleSheetManager, { target: shadowRoot, children: _jsxs(_Fragment, { children: [_jsx(CssBaseline, {}), _jsx(Suspense, { fallback: _jsx("div", { children: "Loading..." }), children: element })] }) }) }) }) }));
    };
    // For .eapFormHolder (possibly multiple instances)
    if (document.querySelector(".eapFormHolder")) {
        MainForm().then(({ Lazy }) => {
            document.querySelectorAll(".eapFormHolder").forEach((el) => {
                if (el instanceof HTMLElement) {
                    mountInDom(el, _jsx(Lazy, {}));
                }
            });
        });
    }
    // Singleton mount points
    const mountPoints = [
        { id: "eapMainPricingPage-4", loader: Pricing },
        { id: "eapMainTeamPage", loader: Teams },
        { id: "eapBillingUpdater-4", loader: BillingUpdate },
        { id: "eapPPC", loader: PpcPage },
        { id: "eapPROMO", loader: PromoLander },
    ];
    mountPoints.forEach(({ id, loader }) => {
        const el = document.getElementById(id);
        if (el) {
            loader().then(({ Lazy }) => {
                mountInDom(el, _jsx(Lazy, {}));
            });
        }
    });
    // Optional: social proof
    // const socialId = 'socialProofPricing';
    // if (!document.getElementById(socialId)) {
    //   const div = document.createElement('div');
    //   div.id = socialId;
    //   document.body.appendChild(div);
    //   mountInShadow(div, <SocialProof />);
    // }
});
